export enum EditorCultureCode {
    ENGLISH = 'en',
    FRENCH = 'fr',
    SPANISH = 'es'
}
